export const getNlisHoldings = (state: State): StateModelById<NlisHolding> =>
  state.nlisFiles.holdings.byId;

export const getIsFetchingNlisHoldings = (state: State): boolean =>
  state.nlisFiles.holdings.isFetching;

// -----------------------------------------------
// Scan Label State Selectors
// -----------------------------------------------
export const getScanLabels = (state: State) => state.scanLabels.byId;
export const getIsFetchingScanLabels = (state: State) =>
  state.scanLabels.isFetching;

// -----------------------------------------------
// Master Ledger Account State Selectors
// -----------------------------------------------
export const getMasterLedgerAccounts = (
  state: State,
): StateModelById<MasterLedgerAccount> => state.masterLedgerAccounts.byId;
